// extracted by mini-css-extract-plugin
export default {"card-list":"CardListing_card-list__hoNCW"};